import type { SampleOrderDataQuery } from '@packages/gql/generated/shopping/graphql';

export const enum SampleOrderSteps {
  'SelectSamples' = 0,
  'PersonalDataForm' = 1,
  'Review' = 2,
  'Finished' = 3,
}

export type SampleGroup = NonNullable<SampleOrderDataQuery['sample']>['samples'][number];

export type SampleEntry = NonNullable<NonNullable<SampleGroup>['values']>[number];
